export default "__VITE_ASSET__99ca81f1__"